import { FormType } from 'constants/forms';
import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export const FORMS_ROUTING_PARAMS = {
  formId: 'formId',
  area: 'area',
  historyEntityId: 'historyEntityId',
  formType: 'formType',
  selectedPage: 'selectedPage',
  coborrowersNumber: 'coborrowersNumber',
  nonborrowersNumber: 'nonborrowersNumber',
  loanId: 'loanId',
  loanNumber: 'loanNumber',
  signingRequestId: 'signingRequestId',
};

export const FORM_BUNDLES_ROUTING_PARAMS = {
  formBundleId: 'formBundleId',
};

// TODO: refactor this part (lead to single REST way)
export class FormsPaths {
  static forms = new EnhancedPath('/forms');

  static formsInArea = new EnhancedPath(`${FormsPaths.forms.path}/:${FORMS_ROUTING_PARAMS.area}?`);

  static form = new EnhancedPath(
    `${FormsPaths.formsInArea.path}/:${FORMS_ROUTING_PARAMS.formId}?/:${FORMS_ROUTING_PARAMS.formType}?/:${FORMS_ROUTING_PARAMS.selectedPage}?`,
  );

  static editForm = new EnhancedPath(`${FormsPaths.form.path}/edit`);

  static viewForm = new EnhancedPath(
    `${FormsPaths.form.path}/view/:${FORMS_ROUTING_PARAMS.historyEntityId}?`,
  );

  static generateFormForLoan = new EnhancedPath(
    `${FormsPaths.forms.path}/:${FORMS_ROUTING_PARAMS.formId}/loan-number/:${FORMS_ROUTING_PARAMS.loanNumber}/generate`,
  );

  static formBundle = new EnhancedPath('/form-bundle');

  static viewFormBundle = new EnhancedPath(
    `${FormsPaths.formBundle.path}/:${FORM_BUNDLES_ROUTING_PARAMS.formBundleId}`,
  );

  static previewForm = new EnhancedPath(
    `${FormsPaths.forms.path}/formId/:${FORMS_ROUTING_PARAMS.formId}/formType/:${FORMS_ROUTING_PARAMS.formType}/selectedPage/:${FORMS_ROUTING_PARAMS.selectedPage}/coborrowersNumber/:${FORMS_ROUTING_PARAMS.coborrowersNumber}/nonborrowersNumber/:${FORMS_ROUTING_PARAMS.nonborrowersNumber}?/loanId/:${FORMS_ROUTING_PARAMS.loanId}?/historyEntityId/:${FORMS_ROUTING_PARAMS.historyEntityId}?/preview`,
  );

  static formBundleTestingTool = new EnhancedPath('/form-bundle-tester');
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: FormsPaths.previewForm.path,
      component: lazyWithRetry(() => import('app/pages/system/forms/FormPreview')),
      pageCode: PAGE_CODES.FORMS,
    },
    {
      path: FormsPaths.generateFormForLoan.path,
      component: lazyWithRetry(() => import('app/pages/system/forms/LoanFormPreview')),
      pageCode: PAGE_CODES.LOAN_APPLICATION,
    },
    {
      path: `${FormsPaths.form.path}`,
      component: lazyWithRetry(() => import('app/pages/system/forms/FormsPage')),
      pageCode: PAGE_CODES.FORMS,
      routes: [
        {
          path: FormsPaths.viewForm.path,
          component: lazyWithRetry(() => import('app/pages/system/forms/FormViewer')),
          pageCode: PAGE_CODES.FORMS,
        },
        {
          path: FormsPaths.editForm.generatePath({
            [FORMS_ROUTING_PARAMS.formId]: `:${FORMS_ROUTING_PARAMS.formId}`,
            [FORMS_ROUTING_PARAMS.area]: `:${FORMS_ROUTING_PARAMS.area}`,
            [FORMS_ROUTING_PARAMS.selectedPage]: `:${FORMS_ROUTING_PARAMS.selectedPage}`,
            [FORMS_ROUTING_PARAMS.formType]: FormType.PDF,
          }),
          component: lazyWithRetry(() => import('app/pages/system/forms/FormViewer')),
          pageCode: PAGE_CODES.FORMS,
        },
        {
          path: FormsPaths.editForm.generatePath({
            [FORMS_ROUTING_PARAMS.formId]: `:${FORMS_ROUTING_PARAMS.formId}`,
            [FORMS_ROUTING_PARAMS.area]: `:${FORMS_ROUTING_PARAMS.area}`,
            [FORMS_ROUTING_PARAMS.selectedPage]: `:${FORMS_ROUTING_PARAMS.selectedPage}`,
            [FORMS_ROUTING_PARAMS.formType]: FormType.CUSTOM,
          }),
          component: lazyWithRetry(() => import('app/pages/system/forms/FormViewer')),
          pageCode: PAGE_CODES.FORMS,
        },
        {
          path: FormsPaths.editForm.generatePath({
            [FORMS_ROUTING_PARAMS.formId]: `:${FORMS_ROUTING_PARAMS.formId}`,
            [FORMS_ROUTING_PARAMS.area]: `:${FORMS_ROUTING_PARAMS.area}`,
            [FORMS_ROUTING_PARAMS.selectedPage]: `:${FORMS_ROUTING_PARAMS.selectedPage}`,
            [FORMS_ROUTING_PARAMS.formType]: FormType.HTML,
          }),
          component: lazyWithRetry(() => import('app/pages/system/forms/FormBuilder')),
          pageCode: PAGE_CODES.FORMS,
        },
      ],
    },
    {
      path: `${FormsPaths.formBundle.path}`,
      component: lazyWithRetry(() => import('app/pages/system/forms/formBundles/FormBundlesPage')),
      pageCode: PAGE_CODES.FORM_BUNDLE,
      routes: [
        {
          path: FormsPaths.viewFormBundle.path,
          component: lazyWithRetry(() => import('app/pages/system/forms/formBundles/FormBundle')),
          pageCode: PAGE_CODES.FORM_BUNDLE,
        },
      ],
    },
    {
      path: FormsPaths.formBundleTestingTool.path,
      component: lazyWithRetry(() => import('app/pages/system/forms/formBundleTestingTool')),
      pageCode: PAGE_CODES.FORM_BUNDLE_TESTING_TOOL,
    },
  ],
};

export default routesConfig;
